import { useEffect } from "react";

export default function LoginNuevo() {
  useEffect(() => {
    if (window.mountLogin) {
      window.mountLogin("login-nuevo");
    }
  }, []);

  return <div id="login-nuevo"></div>;
}